import React from 'react';
import { makeStyles } from '@mui/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: "100%"
    },
    selectEmpty: {
    },
}));

export default function SelectComponent(props) {
    const classes = useStyles();

    const handleChange = (event) => {
        if (props.onChange) {
            props.onChange(event.target.value);
        }
    };

    
    const value = props.value !== undefined && props.value !== null ? props.value : '';

    const items = props.items ? props.items : []; //Se items = null o UNDEFINED seta un []


    return (
        <div style={props.style ? props.style : null}>
            <FormControl className={classes.formControl}>
                <InputLabel id="cabinet-select-label" required={props.required}>{props.inputLabel}</InputLabel>
                <Select
                    labelId="cabinet-select-label"
                    id="cabinet-select"
                    value={value}
                    onChange={handleChange}
                    label={props.inputLabel}
                    disabled={props.disabled === true ? true : false}
                    endAdornment={props.endAdornment}
                    fullWidth>
                    {items.map((item) => (
                        <MenuItem key={item.uuid} value={item.uuid}>{item.name ? item.name : item.sn }</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
